import { invokeAmTpDemoAiTask } from './invokeAmTpDemoAiTask';
import { TAmDemoAiContextFor } from './types';

/**
 * Drafts the functional analysis from the interview transcript.
 *
 * Called from both the chat and the workflow's LLM node, and returns an identical result from either — that
 * sameness is the point, so neither call site passes anything identifying itself.
 */
export async function extractAmTpDemoFarAnalysis(
  context: TAmDemoAiContextFor<'far.extract'>
) {
  return invokeAmTpDemoAiTask('far.extract', context);
}
